export default {
  filterData : {
    Products: {
      label: 'Produkty',
      allFilterLabel: "Wszystkie produkty",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Tematy",
      allFilterLabel: "Wszystkie tematy",
      items: [
        { name: "Zarządzanie dostępem", id: "Access management" },
        { name: "Analityka i monitorowanie", id: "Analytics and monitoring" },
        { name: "Dostarczanie aplikacji i bezpieczeństwo", id: "Application delivery and security" },
        { name: "Citrix i Google", id: "Citrix and Google" },
        { name: "Citrix i Microsoft", id: "Citrix and Microsoft" },
        { name: "Migracja do chmury", id: "Cloud migration" },
        { name: "Porównaj", id: "Compare" },
        { name: "Współpraca nad treściami", id: "Content collaboration" },
        { name: "Wirtualne środowiska pracy", id: "Digital workspaces" },
        { name: "Doświadczenia pracowników", id: "Employee experience" },
        { name: "Chmura hybrydowa", id: "Hybrid cloud" },
        { name: "Praca hybrydowa", id: "Hybrid work" },
        { name: "Zarządzanie i optymalizacja", id: "Manage and optimize" },
        { name: "Mikrousługi i zespoły deweloperów", id: "Microservices and devOps" },
        { name: "Przystosowanie i adaptacja", id: "Onboarding and adoption" },
        { name: "Integracja rozwiązań partnerów", id: "Partner integrations" },
        { name: "Przegląd produktów", id: "Product overview" },
        { name: "Bezpieczeństwo i zgodność z przepisami", id: "Security and compliance" },
        { name: "Małe firmy", id: "Small business" },
        { name: "Dane techniczne", id: "Specifications" },
        { name: "Zrównoważony rozwój", id: "Sustainability" },
        { name: "Ujednolicone zarządzanie punktami końcowymi (UEM)", id: "Unified endpoint management" },
        { name: "VDI i DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: 'Typ',
      allFilterLabel: "Wszystkie rodzaje",
      items: [
        { name: "Raport analityczny", id: "Analyst report" },
        { name: "Narzędzie oceny", id: "Assessment tool" },
        { name: "Historia klientów", id: "Customer story" },
        { name: "Dane techniczne", id: "Data sheet" },
        { name: "Prezentacja", id: "Demo" },
        { name: "eBook", id: "eBook" },
        { name: "Kieruj", id: "Guide" },
        { name: "Infografika", id: "Infographic" },
        { name: "Interaktywne prezentacje", id: "Interactive tour" },
        { name: "Podcast", id: "Podcast" },
        { name: "Zestaw zasobów", id: "Resource kit" },
        { name: "Krótki opis rozwiązania", id: "Solution brief" },
        { name: "Krótki opis techniczny", id: "Technical brief" },
        { name: "Wideo", id: "Video" },
        { name: "Webinarium", id: "Webinar" },
        { name: "Dokument przeglądowy", id: "White paper" },
      ],
    },
    Industry: {
      label: "Przemysł",
      allFilterLabel: "Wszystkie branże",
      items: [
        { name: "Edukacja", id: "education" },
        { name: "Usługi finansowe", id: "financial_service" },
        { name: "Administracja publiczna", id: "government" },
        { name: "Służba zdrowia", id: "healthcare" },
        { name: "Produkcja", id: "manufacturing" },
        { name: "Handel detaliczny", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Przeszukaj bibliotekę",
    titles : {
      label1: "Popularne w tej chwili",
      label2: "Najnowsze zasoby",
      label3: "Ostatnio przeglądane",
      label4: "Polecane zasoby"
    },
    showMoreLabel: "Pokaż więcej",
    clearAllSelected: "Wyczyść wszystkie wybrane",
    searchResults: "Wyniki wyszukiwania",
    clearAllFilters: "Wyczyść wszystkie filtry",
    noResultsFound: "Żadne zasoby nie spełniają wybranych kryteriów",
    resetView: "Resetuj widok",
    filterLabel: "Filtr",
    filteredRes: "Filtrowane wyniki",
    filterRes: "Filtruj wyniki",
    clearAllCta: "Wyczyść wszystko",
    applyCta: "Zastosuj",
    view: "Wyświetl",
    includeEnglishRes: "Zawiera materiały w języku angielskim"
  };